import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';

@Component({
  selector: 'itpx-deliverable-state-presentation',
  templateUrl: './deliverable-state-presentation.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliverableStatePresentationComponent implements OnInit {

  @Input() props: { props: any, conf: MaterialConfiguration };
  @Input() state$: Observable<any>;
  private sharedState$:Observable<any>;
  private tagType: string;
  private classType: string;

  constructor() { }

  ngOnInit() {
    Object.assign(this, this.props.conf);
    this.sharedState$ = this.state$.shareReplay(1);
    // this.sharedState$.subscribe(res => console.log(res));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/deliverable-state-presentation/deliverable-state-presentation.component.ts